<div class="modal-header">
    <h2 mat-dialog-title trans>UTM Builder</h2>
    <button type="button" (click)="close()" class="close-button no-style" tabindex="-1">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>

<form (ngSubmit)="save()" ngNativeValidate [formGroup]="form">
    <mat-dialog-content>
        <div class="inline-inputs-container many-inputs">
            <div class="input-container">
                <label for="utm-source" trans>Source</label>
                <input
                    type="text"
                    id="utm-source"
                    placeholder="e.g: adwords, google, facebook"
                    trans-placeholder
                    formControlName="utm_source"
                />
            </div>
            <div class="input-container">
                <label for="utm-medium" trans>Medium</label>
                <input
                    type="text"
                    id="utm-medium"
                    placeholder="e.g: banner, email, social post"
                    trans-placeholder
                    formControlName="utm_medium"
                />
            </div>
        </div>

        <div class="inline-inputs-container many-inputs">
            <div class="input-container">
                <label for="utm-campaign" trans>Campaign</label>
                <input
                    type="text"
                    id="utm-campaign"
                    placeholder="e.g: holiday special, birthday promo"
                    trans-placeholder
                    formControlName="utm_campaign"
                />
            </div>
            <div class="input-container">
                <label for="utm-term" trans>Term</label>
                <input
                    type="text"
                    id="utm-term"
                    placeholder="Use to identify ppc keywords"
                    trans-placeholder
                    formControlName="utm_term"
                />
            </div>
        </div>

        <div class="inline-inputs-container many-inputs">
            <div class="input-container">
                <label for="utm-content" trans>Content</label>
                <input
                    type="text"
                    id="utm-content"
                    placeholder="Use to differentiate ads or words on a page"
                    trans-placeholder
                    formControlName="utm_content"
                />
            </div>
        </div>

        <div class="widget widget-info">
            <div trans>
                UTM codes specified here will be applied to the link automatically when redirecting
                from short url to destination url.
            </div>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions>
        <button type="submit" mat-raised-button color="accent" trans>Save</button>
    </mat-dialog-actions>
</form>
